export default __webpack_public_path__ + "static/media/Robofriends.1852c702.webp";